import { productSpecificationsEn as base } from './product-specifications-en';

export const productSpecificationsEs = {
  ...base,
  admin: {
    nav: 'Especificaciones de producto',
    title: 'Especificaciones de producto',
    description: 'Defina propiedades, esquemas, declaraciones y diseños PDF versionados.',
  },
  tabs: {
    schemas: 'Esquemas',
    properties: 'Biblioteca de propiedades',
    units: 'Unidades',
    pdfTemplates: 'Diseños PDF',
    declarations: 'Declaraciones',
    settings: 'Configuración',
  },
  actions: {
    create: 'Crear especificación',
    openRevision: 'Abrir revisión',
    backToOverview: 'Volver al resumen',
    backToProduct: 'Volver al producto',
    preview: 'Vista previa',
    publish: 'Publicar',
    validate: 'Validar',
    submit: 'Enviar a revisión',
    requestChanges: 'Solicitar cambios',
    approve: 'Aprobar',
    withdraw: 'Retirar',
    generatePdf: 'Generar PDF',
    download: 'Descargar',
    addRow: 'Añadir fila',
    moveUp: 'Subir',
    moveDown: 'Bajar',
  },
  fields: {
    name: 'Nombre',
    translatedName: 'Nombre traducido',
    title: 'Título',
    text: 'Texto',
    key: 'Clave técnica',
    type: 'Tipo',
    description: 'Descripción',
    schema: 'Esquema',
    revision: 'Revisión',
    version: 'Versión',
    validity: 'Validez',
    validFrom: 'Válido desde',
    changeReason: 'Motivo del cambio',
    reason: 'Motivo',
    translationStatus: 'Estado de traducción',
    sectionKey: 'Clave de sección',
    sectionTitle: 'Título de sección',
    columns: 'Columnas',
    pageBreakBefore: 'Salto de página anterior',
    required: 'Obligatorio',
    dimension: 'Dimensión',
    defaultUnit: 'Unidad predeterminada',
    translatable: 'Traducible',
    sensitive: 'Sensible',
    reportable: 'Evaluable',
    symbol: 'Símbolo',
    decimalPlaces: 'Decimales',
    conversionFactor: 'Factor de conversión',
    conversionOffset: 'Desplazamiento de conversión',
    currency: 'Moneda',
    minimum: 'Mínimo',
    maximum: 'Máximo',
    value: 'Valor',
    unit: 'Unidad',
    tolerance: 'Tolerancia',
    toleranceType: 'Tipo de tolerancia',
    measurementMethod: 'Método de medición',
    remark: 'Observación',
    referenceIds: 'Referencias internas separadas por comas',
    declarationVersionId: 'Versión de declaración',
    confirmed: 'Confirmado',
    confirmationRequired: 'Confirmación obligatoria',
  },
  values: {
    none: 'Ninguna',
    required: 'Obligatorio',
    openEnded: 'sin límite',
    yes: 'Sí',
    no: 'No',
  },
  toleranceTypes: { ABSOLUTE: 'Absoluta', PERCENT: 'Porcentual' },
  states: {
    loadError: 'No se pudieron cargar los datos de especificación.',
    emptyTitle: 'Aún no hay especificaciones',
    emptyDescription: 'Cree una especificación a partir de un esquema publicado.',
    noRevision: 'No hay revisión disponible.',
  },
  product: {
    title: 'Especificaciones de producto',
    description: 'Información de producto versionada, multilingüe y aprobada.',
  },
  create: {
    title: 'Crear especificación de producto',
    description: 'Seleccione un esquema publicado y defina la primera revisión.',
    selectSchema: 'Seleccionar esquema',
    success: 'Especificación creada.',
    error: 'No se pudo crear la especificación.',
  },
  property: {
    ...base.property,
    title: 'Biblioteca de propiedades',
    description: 'Definiciones tipadas reutilizables para cualquier sector.',
    add: 'Añadir propiedad',
    empty: 'No hay propiedades definidas.',
    createSuccess: 'Propiedad creada.',
    createError: 'No se pudo crear la propiedad.',
    types: {
      SHORT_TEXT: 'Texto corto',
      MULTILINE_TEXT: 'Texto multilínea',
      RICH_TEXT: 'Texto enriquecido seguro',
      INTEGER: 'Entero',
      DECIMAL: 'Decimal',
      PERCENT: 'Porcentaje',
      CURRENCY: 'Moneda',
      BOOLEAN: 'Booleano',
      DATE: 'Fecha',
      DATE_TIME: 'Fecha y hora',
      SINGLE_CHOICE: 'Selección única',
      MULTIPLE_CHOICE: 'Selección múltiple',
      TRANSLATABLE_CHOICE: 'Selección traducible',
      MEASUREMENT: 'Valor con unidad',
      RANGE: 'Rango',
      MINIMUM: 'Valor mínimo',
      MAXIMUM: 'Valor máximo',
      TARGET_TOLERANCE: 'Objetivo con tolerancia',
      COMPARISON_MEASUREMENT: 'Medición con operador',
      FORMULA: 'Fórmula',
      IMAGE: 'Imagen',
      IMAGE_GALLERY: 'Galería de imágenes',
      DMS_FILE: 'Archivo DMS',
      CERTIFICATE: 'Referencia de certificado',
      PRODUCT_REFERENCE: 'Referencia de producto',
      URL: 'URL',
      KEY_VALUE_TABLE: 'Tabla clave-valor',
      CUSTOM_TABLE: 'Tabla personalizada',
      MATRIX: 'Matriz',
      LIST: 'Lista',
      NUMBERED_INSTRUCTIONS: 'Instrucciones numeradas',
      DECLARATION: 'Declaración',
      SECTION_HEADING: 'Encabezado de sección',
      INFORMATION: 'Texto informativo',
    },
    configuration: {
      SINGLE_CHOICE: 'Primera opción',
      MULTIPLE_CHOICE: 'Primera opción',
      TRANSLATABLE_CHOICE: 'Primera opción',
      FORMULA: 'Expresión de fórmula',
      KEY_VALUE_TABLE: 'Primera columna',
      CUSTOM_TABLE: 'Primera columna',
      MATRIX: 'Primera columna',
    },
  },
  unit: {
    title: 'Biblioteca de unidades',
    description: 'Dimensiones por tenant y conversiones Decimal exactas.',
    add: 'Añadir unidad',
    createSuccess: 'Unidad creada.',
    createError: 'No se pudo crear la unidad.',
  },
  schema: {
    title: 'Esquemas de especificación',
    description: 'Componga formularios versionados con propiedades reutilizables.',
    add: 'Crear esquema',
    empty: 'No hay esquemas definidos.',
  },
  builder: {
    library: 'Biblioteca de propiedades',
    inspector: 'Inspector',
    addProperty: 'Añadir {{name}}',
    dropHint: 'Suelte aquí una propiedad o use el botón de añadir.',
    addSection: 'Añadir sección',
    saveSuccess: 'Borrador guardado.',
    saveError: 'No se pudo guardar el esquema.',
    versionSuccess: 'Nueva versión creada.',
    draftAlreadyExists: 'Ya existe una versión borrador.',
    validationError: 'Revise las claves, traducciones y configuraciones obligatorias.',
    publishSuccess: 'Esquema publicado.',
    publishError: 'No se pudo publicar el esquema.',
    validationIssues: 'Quedan {{count}} errores de validación.',
  },
  editor: {
    saved: 'Guardado',
    unsaved: 'Guardar cambios',
    saveError: 'No se pudo guardar. Recargue antes de sobrescribir cambios simultáneos.',
    completeness: 'Completitud',
    contents: 'Contenido',
    validationSummary: 'Errores de validación',
    sourceText: 'Texto fuente',
    language: 'Idioma',
    workflow: 'Revisión y aprobación',
    pdf: 'Documentos PDF',
    valid: 'La revisión es válida.',
  },
  sources: {
    type: 'Fuente de datos',
    field: 'Campo de origen',
    key: 'Clave de origen',
    imageVariant: 'Variante de imagen',
    packagingId: 'ID de embalaje (opcional)',
    automaticSelection: 'Selección automática',
    dmsCategory: 'Categoría DMS',
    expression: 'Expresión de fórmula',
    market: 'Mercado',
    parameterKey: 'Clave de análisis (opcional)',
    domainKey: 'Dominio de análisis',
    allParameters: 'Todos los parámetros como tabla',
    display: 'Presentación',
    snapshotOnCreate: 'Congelar fuente al crear',
    refreshOnRevision: 'Actualizar en una nueva revisión',
    copyInitially: 'Copiar valor inicial',
    showLiveInDraft: 'Mostrar fuente activa en borradores',
    readOnly: 'Solo lectura',
    manuallyOverridable: 'Permitir anulación justificada',
    refresh: 'Actualizar fuentes',
    refreshSuccess: 'Se actualizaron los datos de origen y su procedencia.',
    refreshError: 'No se pudieron actualizar los datos de origen.',
    warningTitle: 'Datos de origen incompletos o contradictorios',
    warningItem: 'El campo de origen «{{field}}» está incompleto ({{code}}).',
    overrideReason: 'Motivo de la anulación manual',
    overrideReasonRequired: 'Se requiere un motivo para mantener la trazabilidad.',
    overrideReasonSaved: 'Motivo guardado: {{reason}}',
    provenance: 'Fuente: {{source}} · Versión: {{version}}',
    snapshot: 'instantánea congelada',
    types: {
      MANUAL: 'Entrada manual',
      PRODUCT_FIELD: 'Maestro de artículos',
      PRODUCT_CUSTOM_FIELD: 'Campo de artículo personalizado',
      PRODUCT_CATEGORY: 'Categoría de artículo',
      PRODUCT_IMAGE: 'Imagen de producto',
      PACKAGING: 'Datos de embalaje',
      DMS_ATTACHMENT: 'Adjunto DMS',
      FORMULA: 'Fórmula',
      RECIPE: 'Receta aprobada',
      PRODUCT_DECLARATION: 'Declaración aprobada',
      ALLERGEN: 'Datos de alérgenos',
      NUTRITION: 'Valores nutricionales',
      PROCESS_ROUTING: 'Proceso aprobado',
      YIELD: 'Rendimiento',
      ANALYSIS: 'Valores de análisis',
      MATERIAL_PROFILE: 'Maestro de materiales',
    },
    origins: { MANUAL: 'Manual', AUTOMATIC: 'Automático', MANUAL_OVERRIDE: 'Anulación manual' },
    values: {
      articleNumber: 'Número de artículo',
      name: 'Denominación',
      description: 'Descripción',
      ean: 'EAN',
      manufacturerNumber: 'Referencia del fabricante',
      weightNetKg: 'Peso neto',
      weightGrossKg: 'Peso bruto',
      countryOfOrigin: 'País de origen',
      THUMBNAIL: 'Miniatura',
      LIST: 'Vista de lista',
      CATALOG: 'Vista de catálogo',
      DETAIL: 'Vista detallada',
      ALL: 'Todos',
      GENERAL_FILE: 'Archivo general',
      CERTIFICATE: 'Certificado',
      DATASHEET: 'Ficha técnica',
      NUMBER: 'Número',
      NAME: 'Denominación',
      DESCRIPTION: 'Descripción',
      BASE_QUANTITY: 'Cantidad de referencia',
      BASE_UNIT: 'Unidad base',
      COMPONENTS: 'Componentes',
      INTERNAL_MATERIAL_COST: 'Coste interno de materiales',
      DMS_ATTACHMENTS: 'Documentos DMS',
      PRODUCT_DESIGNATION: 'Denominación del producto',
      INGREDIENT_TEXT: 'Lista de ingredientes',
      ALLERGEN_TEXT: 'Indicación de alérgenos',
      ADDITIVE_TEXT: 'Indicación de aditivos',
      WARNING_TEXT: 'Advertencias',
      COMBINED_TEXT: 'Texto de declaración combinado',
      STEPS: 'Pasos del proceso',
      INSTRUCTIONS: 'Instrucciones de trabajo',
      QUALITY_CHECKS: 'Controles de calidad',
      PHOTOS: 'Fotos del proceso',
      PERCENT: 'Porcentaje',
      FACTOR: 'Factor',
      STANDARD_UNIT: 'Unidad de cantidad estándar',
      DENSITY: 'Densidad',
      ORIGIN: 'Origen',
      MANUFACTURER: 'Fabricante',
      TECHNICAL_PROPERTIES: 'Propiedades técnicas',
      QUALITY_PROPERTIES: 'Propiedades de calidad',
      STORAGE_CONDITIONS: 'Condiciones de almacenamiento',
      STORAGE_INSTRUCTIONS: 'Instrucciones de almacenamiento',
      SHELF_LIFE_DAYS: 'Vida útil en días',
    },
  },
  impact: {
    title: 'Se requiere una nueva revisión',
    description:
      'Han cambiado fuentes aprobadas. Revise el impacto antes de la próxima aprobación.',
    badge: 'Revisión requerida',
    count: '{{count}} cambios de origen afectan a esta especificación.',
    item: 'El origen «{{source}}» ha cambiado.',
  },
  workflow: {
    submitted: 'Revisión enviada.',
    changesRequested: 'Cambios solicitados.',
    approved: 'Revisión aprobada.',
    published: 'Revisión publicada.',
    withdrawn: 'Revisión retirada.',
    error: 'La acción ha fallado.',
  },
  revisionTools: {
    title: 'Revisión y versión del esquema',
    createNext: 'Crear siguiente revisión',
    created: 'Se ha creado una nueva revisión.',
    createError: 'No se pudo crear la nueva revisión.',
    compare: 'Comparar con revisión',
    selectRevision: 'Seleccionar revisión',
    changeCount: '{{count}} cambios',
    noChanges: 'No se encontraron diferencias.',
    changeKind: { ADDED: 'Añadido', REMOVED: 'Eliminado', CHANGED: 'Modificado' },
    migration: 'Migración controlada del esquema',
    selectSchemaVersion: 'Seleccionar versión publicada',
    migrate: 'Crear revisión migrada',
    migrated: 'Se ha creado la revisión borrador migrada.',
    migrationError: 'No se pudo migrar la revisión.',
    migrationCategory: {
      unchanged: 'Campos sin cambios',
      new: 'Campos nuevos',
      removed: 'Campos eliminados',
      incompatible: 'Campos incompatibles',
      carriable: 'Valores transferibles',
      manual: 'Revisión manual',
    },
  },
  settings: {
    title: 'Configuración de especificaciones',
    description: 'Configure las reglas generales de aprobación, validez y nombres de PDF.',
    defaultSourceLocale: 'Idioma fuente predeterminado',
    validityWarningDays: 'Aviso de validez (días)',
    fileNamePattern: 'Patrón de nombre de archivo PDF',
    fileNamePatternHelp:
      'Tokens disponibles: {{articleNumber}}, {{specificationKey}}, {{revision}}, {{locale}}.',
    requireFourEyes: 'Exigir aprobación por cuatro ojos de forma predeterminada',
    creatorMayApprove: 'Permitir que el creador apruebe',
    createPdfOnPublish: 'Crear PDF al publicar',
    saved: 'Configuración guardada.',
    saveError: 'No se pudo guardar la configuración.',
  },
  declaration: {
    title: 'Declaraciones y certificados',
    description: 'Mantenga textos legales y sectoriales como versiones configurables.',
    createSuccess: 'Declaración creada.',
    createError: 'No se pudo crear la declaración.',
    publishSuccess: 'Declaración publicada.',
    publishError: 'No se pudo publicar la declaración.',
  },
  pdf: {
    ...base.pdf,
    title: 'Diseñador PDF de especificaciones',
    description: 'Dominio de diseño de flujo dinámico basado en la infraestructura PDF común.',
    blockLibrary: 'Biblioteca de bloques',
    inspector: 'Inspector de página',
    blockText: 'Texto traducido del bloque',
    addBlock: 'Añadir bloque',
    pagePreview: 'Vista de impresión',
    createSuccess: 'Diseño PDF creado.',
    createError: 'No se pudo crear el diseño PDF.',
    publishSuccess: 'Diseño PDF publicado.',
    publishError: 'No se pudo publicar el diseño PDF.',
    previewError: 'Falló la vista previa PDF.',
    previewTitle: 'Vista previa de la especificación PDF',
    queued: 'Generación PDF en cola.',
    combined: 'Idiomas combinados',
    attachments: 'Anexos DMS opcionales',
    attachmentCount: '{{count}} anexos congelados',
    generateCombined: 'Documento multilingüe combinado',
    versionCount: '{{count}} versiones',
    status: { PENDING: 'En cola', PROCESSING: 'Generando', READY: 'Listo', FAILED: 'Fallido' },
    blocks: {
      COMPANY_LOGO: 'Logotipo',
      COMPANY_ADDRESS: 'Dirección de empresa',
      DOCUMENT_TITLE: 'Título del documento',
      PRODUCT_NAME: 'Nombre del producto',
      ARTICLE_NUMBER: 'Número de artículo',
      PRODUCT_CATEGORY: 'Categoría de producto',
      PRODUCT_IMAGE: 'Imagen del producto',
      IMAGE_GALLERY: 'Galería de imágenes',
      SPECIFICATION_NUMBER: 'Número de especificación',
      REVISION_NUMBER: 'Número de revisión',
      STATUS: 'Estado',
      VALIDITY_DATE: 'Validez',
      CREATED_DATE: 'Fecha de creación',
      APPROVED_DATE: 'Fecha de aprobación',
      SECTION: 'Sección de especificación',
      PROPERTY: 'Propiedad',
      PROPERTY_GROUP: 'Grupo de propiedades',
      DYNAMIC_TABLE: 'Tabla dinámica',
      MATRIX: 'Matriz',
      LONG_TEXT: 'Texto largo',
      NOTICE: 'Aviso',
      CERTIFICATE_LIST: 'Lista de certificados',
      DMS_FILE_LIST: 'Lista de archivos DMS',
      ATTACHMENT_LIST: 'Lista de anexos',
      APPROVAL: 'Bloque de aprobación',
      REVISION_HISTORY: 'Historial de revisiones',
      TABLE_OF_CONTENTS: 'Índice',
      HEADER: 'Encabezado',
      FOOTER: 'Pie de página',
      PAGE_NUMBER: 'Número de página',
      CONFIDENTIALITY: 'Confidencialidad',
      WATERMARK: 'Marca de agua',
      QR_CODE: 'Código QR de verificación',
      STATIC_TEXT: 'Texto estático traducido',
      CONDITIONAL: 'Bloque condicional',
    },
  },
  status: {
    schema: { NEW: 'Nuevo', DRAFT: 'Borrador', PUBLISHED: 'Publicado', ARCHIVED: 'Archivado' },
    revision: {
      DRAFT: 'Borrador',
      IN_REVIEW: 'En revisión',
      CHANGES_REQUESTED: 'Cambios solicitados',
      APPROVED: 'Aprobado',
      PUBLISHED: 'Publicado',
      SUPERSEDED: 'Sustituido',
      WITHDRAWN: 'Retirado',
    },
    translation: {
      NOT_STARTED: 'No iniciado',
      IN_PROGRESS: 'En curso',
      IN_REVIEW: 'En revisión',
      APPROVED: 'Aprobado',
    },
  },
  operators: {
    EQUAL: '=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL: '≤',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL: '≥',
    RANGE: 'Rango',
    APPROXIMATELY: 'Aproximadamente',
    NOT_DETECTABLE: 'No detectable',
    PASSED: 'Aprobado',
    FAILED: 'No aprobado',
  },
} as const;
